import { createControlComponent } from '@react-leaflet/core'
import { Control } from 'leaflet'
import 'leaflet.fullscreen'

// @ts-ignore
export const FullscreenControl = createControlComponent((props) => new Control.FullScreen(props))

export const Zoom = createControlComponent((props) => new Control.Zoom(props))
